<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title Bank Account (PV)
          v-spacer
          v-btn(dark, color="blue-secondary", to="/pv-bank-accounts/create" class="elevation-0") CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-select.hidden-sm-and-down.col-3.pl-0(
            label="Business Unit",
            v-model="selectedBU",
            :items="filteredBUList",
            item-text="business_unit.bu_name",
            item-value="business_unit.id",
            clearable,
            hide-details,
            @change="onBUChange"
          )
            template(v-slot:item="data")
              v-list-item-title {{ getBUName(data.item) }}
            template(v-slot:selection="data")
              span {{ getBUName(data.item) }}
          span.pr-2
          v-select.hidden-sm-and-down.col-2.pl-0(
            multiple
            label="Status"
            hide-details
            v-model="selectedIsActive"
            :items="statusOptions"
            item-value="value"
            item-text="text"
            @change="onStatusChange"
          )
            template(v-slot:prepend-item)
              v-list-item(ripple @mousedown.prevent @click="toggleStatus")
                v-list-item-action
                  v-icon(:color="selectedIsActive.length > 0 ? 'indigo darken-4' : ''") {{ iconXStatus }}
                v-list-item-content
                  v-list-item-title Select All
              v-divider(class="mt-2")
            template(v-slot:selection="{ item, index }")
              v-chip(
                v-if="selectedIsActive.length == 1"
                close
                @click:close="removeStatus(item.value)"
              )
                span {{ item.text }}
              v-chip(
                v-else-if="index===1"
                close
                @click:close="removeAllStatus"
              )
                span {{ selectedIsActive.length }} Status
          span.pr-2
          v-text-field.hidden-sm-and-down.col-5(
            flat,
            append-icon="search",
            placeholder="Search by Bank, Account Name, or Account No",
            v-model="keyword",
            hide-details,
            @keyup.enter="loadData"
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :loading="loading",
            :server-items-length="totalItems",
            :items-per-page="itemsPerPage",
            :page="page",
            @update:options="onPaginationChange"
          )
            template(v-slot:item.is_active="{ item }")
              v-chip(:color="getIsActiveValue(item) ? 'success' : 'default'", small) {{ getIsActiveValue(item) ? 'Active' : 'Non Active' }}
            
            template(v-slot:item.updated_at="{ item }")
              span {{ formatDate(item.updated_at) }}

            template(v-slot:item.data-table-expand="{ item }")
              v-icon.mr-2(
                v-if="!item.is_used"
                title="edit",
                color="green",
                @click="onEdit(item._id)"
              )
                | edit

            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "PVBankAccountList",
  data() {
    return {
      keyword: "",
      selectedBU: "",
      selectedIsActive: [],
      buList: [],
      statusOptions: [
        { text: "Active", value: true },
        { text: "Non Active", value: false },
      ],
      dataHeaders: [
        { text: "BU", value: "bu.name", sortable: true },
        { text: "Bank", value: "bank.name", sortable: true },
        { text: "Account Name", value: "account_name", sortable: true },
        { text: "Account No", value: "account_no", sortable: true },
        { text: "Status", value: "is_active", sortable: true },
        { text: "Updated At", value: "updated_at", sortable: true },
        { text: "Actions", value: "data-table-expand", sortable: false },
      ],
      dataItems: [],
      loading: false,
      totalItems: 0,
      itemsPerPage: 10,
      page: 1,
      sortBy: "updated_at",
      sortOrder: "desc",
    };
  },
  computed: {
    filteredBUList() {
      return this.buList.filter(item => {
        return item.business_unit &&
               item.business_unit.is_active === true &&
               item.is_payment_voucher === true;
      });
    },
    accessibleBUIds() {
      return this.filteredBUList
        .map(item => (item.business_unit && item.business_unit.id ? item.business_unit.id : null))
        .filter(id => id);
    },
    selectAllStatus() {
      return this.selectedIsActive.length === this.statusOptions.length;
    },
    selectSomeStatus() {
      return this.selectedIsActive.length > 0 && !this.selectAllStatus;
    },
    iconXStatus() {
      if (this.selectAllStatus) return 'close';
      else if (this.selectSomeStatus) return 'clear_all';
      else return 'check_box_outline_blank';
    },
  },
  mounted() {
    this.loadBUList();
  },
  methods: {
    loadBUList() {
      const token = localStorage.getItem("token");
      const userData = this.$store.state.dataUsers;
      const userId = userData.user || userData;
      
      if (userId) {
        axios
          .get(`${process.env.VUE_APP_API}/users/active/bu/${userId._id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.buList = res.data.data || [];
            this.loadData();
          })
          .catch((err) => {
            this.$toasted.error("Failed to load business units", { icon: "error" });
            // Still load data even if BU list fails
            this.loadData();
          });
      } else {
        this.loadData();
      }
    },
    loadData() {
      this.loading = true;
      const token = localStorage.getItem("token");
      
      const params = {
        page: this.page,
        limit: this.itemsPerPage,
        sort: this.sortBy,
        order: this.sortOrder,
      };
      
      if (this.selectedBU) {
        params.bu = this.selectedBU;
      } else if (this.accessibleBUIds.length > 0) {
        params.bu = this.accessibleBUIds.join(",");
      }
      if (this.keyword) params.q = this.keyword;
      if (this.selectedIsActive.length > 0) {
        // Send is_active as comma-separated boolean values
        params.is_active = this.selectedIsActive.join(",");
      }
      
      axios
        .get(`${process.env.VUE_APP_API}/pv/bank-accounts`, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        })
        .then((res) => {
          this.dataItems = res.data.data || [];
          this.totalItems = res.data.pagination && res.data.pagination.total || 0;
        })
        .catch((err) => {
          this.$toasted.error("Failed to load data", { icon: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBUChange(value) {
      if (!value) {
        this.selectedBU = "";
      }
      this.page = 1;
      this.loadData();
    },
    onStatusChange() {
      this.page = 1;
      this.loadData();
    },
    toggleStatus() {
      this.$nextTick(() => {
        if (this.selectAllStatus) {
          this.selectedIsActive = [];
        } else {
          this.selectedIsActive = this.statusOptions.map(s => s.value);
        }
        this.onStatusChange();
      });
    },
    removeStatus(value) {
      const idx = this.selectedIsActive.indexOf(value);
      if (idx > -1) {
        this.selectedIsActive.splice(idx, 1);
        this.selectedIsActive = [...this.selectedIsActive];
        this.onStatusChange();
      }
    },
    removeAllStatus() {
      this.selectedIsActive = [];
      this.onStatusChange();
    },
    onPaginationChange(options) {
      const nextPage = options.page || 1;
      const nextItemsPerPage = options.itemsPerPage || 10;
      const hasSort = options.sortBy && options.sortBy.length > 0;
      const nextSortBy = hasSort ? options.sortBy[0] : this.sortBy;
      const nextSortOrder = hasSort && options.sortDesc ? (options.sortDesc[0] ? "desc" : "asc") : this.sortOrder;

      const unchanged =
        this.page === nextPage &&
        this.itemsPerPage === nextItemsPerPage &&
        this.sortBy === nextSortBy &&
        this.sortOrder === nextSortOrder;

      if (unchanged) {
        return;
      }

      this.page = nextPage;
      this.itemsPerPage = nextItemsPerPage;
      this.sortBy = nextSortBy;
      this.sortOrder = nextSortOrder;
      
      this.loadData();
    },
    onEdit(id) {
      this.$router.push({
        name: "PV Bank Account Edit",
        params: { id },
      });
    },
    formatDate(date) {
      return moment(date).format("DD MMM YYYY HH:mm");
    },
    getBUName(item) {
      if (item && item.business_unit && item.business_unit.bu_name) {
        return item.business_unit.bu_name;
      }

      return item && item.text ? item.text : "";
    },
    getIsActiveValue(item) {
      // Handle backward compatibility: convert old status field to is_active
      if (item.is_active !== undefined) {
        return item.is_active;
      }
      // If old status field exists, convert it
      if (item.status !== undefined) {
        return item.status === 'Active';
      }
      return false;
    },
  },
};
</script>

<style scoped>
.empty__title {
  font-size: 18px;
  font-weight: 600;
}
.empty__subtitle {
  color: #999;
  font-size: 14px;
}
</style>
